var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 80,
    viewBox: "0 0 67 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 76.5L21.6667 58.3333L33.3333 68.3333L51.6667 43.3333L63.1667 56.4762V23.3333H43.3333V3.5H3.5V76.5ZM2 0H46.6667L56.6667 10L66.6667 20V78C66.6667 79.1046 65.7712 80 64.6667 80H2C0.895429 80 0 79.1046 0 78V2C0 0.895429 0.895431 0 2 0ZM26.6667 38.3333C26.6667 41.0948 24.4281 43.3333 21.6667 43.3333C18.9052 43.3333 16.6667 41.0948 16.6667 38.3333C16.6667 35.5719 18.9052 33.3333 21.6667 33.3333C24.4281 33.3333 26.6667 35.5719 26.6667 38.3333Z",
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/PhotoIcon.55666a77108f86a260972f6bc944e9df.svg";
export { ForwardRef as ReactComponent };